// Session datetimes come from the API as "YYYY-MM-DD HH:MM:SS" strings
// (knex dateStrings), so plain string slicing avoids timezone reinterpretation.

export const dateOf = (dateTime) => dateTime.slice(0, 10);

export const timeOf = (dateTime) => dateTime.slice(11, 16);

export const minutesOf = (dateTime) =>
  Number(dateTime.slice(11, 13)) * 60 + Number(dateTime.slice(14, 16));
